import React from 'react'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import DownLoadIcon from 'components/icons/DownLoad'
import UploadIcon from 'components/icons/UploadIcon'
import {
  StyledUpload,
  UploadFlex,
  UploadIconDiv,
  UploadFileDiv,
  FileNameDiv,
} from '../UploadShortlistedDrawer/style'
import { FooterFlex } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import FileReader from 'components/Uploader/FileReader'
import { CandiadateFlex, DocFlex, CandidateInfo, TemolateDiv } from 'modules/Drives/DownloadAndUpload/UploadResultDrawer/style';
import { uploadFile } from 'modules/ManageProfile/actions'
import { useDispatch } from 'react-redux'

const UploadAssessmentDrawer = ({
  uploadShortlisted,
  setUploadShortlisted,
  setIsDrawer,
  downloadCandidateSampleTemplate,
  setIsFileLoader,
  fileURL,
  setFileURL,
  file,
  setFile,
  loading,
  handleAssessmentConfirm,
  setErrorMessage,
  nextRoundData,
}) => {

  const dispatch = useDispatch()
  const onClose = () => {
    setUploadShortlisted(false)
    setIsDrawer(true)
    setFile(null)
    setFileURL('')
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }


  const onChangeFileUpload = async info => {
    setIsFileLoader(true)

    if (info?.file?.status === 'done') {
      setFile(info?.file)
      let response = await dispatch(
        uploadFile(info?.file?.originFileObj, info?.file?.name)
      )
      if (response) {
        setFileURL(response)
        setIsFileLoader(false)
      }
    }
  
  }


  const content = () => {
    return (
      <>

            <CandiadateFlex spaceBetween row centerVertically>
              <div style={{ display: 'flex', gap: '20px' }}>
                <DownLoadIcon />
                <DocFlex column>
                  <CandidateInfo>Candidate Sample Doc</CandidateInfo>
                  <TemolateDiv>
                    To upload bulk upload data, use the template
                  </TemolateDiv>
                </DocFlex>
              </div>
              <Button.Secondary
                width="144px"
                height="32px"
                text="Download Sample"
                htmlType="button"
                onClick={downloadCandidateSampleTemplate}
              />
            </CandiadateFlex>



        {/* File Upload Area */}
        <StyledUpload
          multiple={false}
          type="file"
          accept={'.xlsx,.xls,.csv'}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          itemRender={() => null}
        >
          <UploadFlex column alignCenter style={{ marginTop: '20px' }}>
            <UploadIconDiv>
              <UploadIcon />
            </UploadIconDiv>
            <UploadFileDiv>Browse for file or Drag and drop</UploadFileDiv>
            <FileNameDiv>Format (.xls, .xlsx, .csv)</FileNameDiv>
          </UploadFlex>
          {fileURL && (
            <FileReader
              file={file}
              setFile={setFile}
              fileURL={fileURL}
              setFileURL={setFileURL}
              setErrorMessage={setErrorMessage}
            />
          )}
        </StyledUpload>
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <Button.Secondary width="88px" text="Cancel" onClick={onClose} />
        <Button.Primary
          width="110px"
          text={fileURL ? 'Update' : 'Next'}
          loading={loading}
          onClick={() => handleAssessmentConfirm(nextRoundData[0]?.name)}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="40%"
        title={'Upload Result'}
        placement="right"
        visible={uploadShortlisted}
        content={content()}
        footer={footer()}
        onClose={onClose}
        closable
      />
    </>
  )
}

export default UploadAssessmentDrawer
